import { render, staticRenderFns } from "./left-arrow.vue?vue&type=template&id=531e44c8&scoped=true&"
import script from "./left-arrow.vue?vue&type=script&lang=js&"
export * from "./left-arrow.vue?vue&type=script&lang=js&"
import style0 from "./left-arrow.vue?vue&type=style&index=0&id=531e44c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531e44c8",
  null
  
)

export default component.exports